export default __webpack_public_path__ + "static/last_year_4-871fee627c2257cfa8ac5c4e0e2a6074.webp";